import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import LoanProgramDetail from "./pages/LoanProgramDetail";
import LoanPrograms from "./pages/LoanPrograms";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Apply from "./pages/Apply";
import Admin from "./pages/Admin";
import Tools from "./pages/Tools";
import PersonalLoans from "./pages/PersonalLoans";
import ChatWidget from "./components/ChatWidget";
import { Toaster } from "./components/ui/toaster";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/loan-programs" element={<LoanPrograms />} />
          <Route path="/loan-programs/:slug" element={<LoanProgramDetail />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/apply" element={<Apply />} />
          <Route path="/tools" element={<Tools />} />
          <Route path="/personal-loans" element={<PersonalLoans />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
        <Footer />
        <ChatWidget />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
